// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_OneOf from "../Data.OneOf/index.js";
import * as Data_Variant from "../Data.Variant/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Record from "../Record/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var match = /* #__PURE__ */ Data_Variant.match()()();
var on = /* #__PURE__ */ Data_OneOf.on();
var on1 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "ValidationFailed";
    }
});
var on2 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "UnknownError";
    }
});
var on3 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "UnexpectedStatus";
    }
});
var on4 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "Unauthorized";
    }
});
var on5 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "ServerError";
    }
});
var on6 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "NetworkError";
    }
});
var on7 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "DecodingError";
    }
});
var on8 = /* #__PURE__ */ on({
    reflectSymbol: function () {
        return "GenericError";
    }
});
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var translateOneOfNilRow = {
    oneOfMatchFn: {}
};
var translateError = function (dict) {
    return dict.translateError;
};
var oneOfMatchFn = function (dict) {
    return dict.oneOfMatchFn;
};
var translateOneOfCons = function (dictIsSymbol) {
    var insert = Record.insert(dictIsSymbol)()();
    return function () {
        return function (dictGetTranslation) {
            var getTranslation = Restaumatic_I18n.getTranslation(dictGetTranslation);
            return function (dictTranslateOneOf) {
                var oneOfMatchFn1 = oneOfMatchFn(dictTranslateOneOf);
                return function () {
                    return {
                        oneOfMatchFn: insert(Type_Proxy["Proxy"].value)(function (v) {
                            return getTranslation(Type_Proxy["Proxy"].value);
                        })(oneOfMatchFn1)
                    };
                };
            };
        };
    };
};
var translatedErrorOneOf = function () {
    return function (dictTranslateOneOf) {
        var oneOfMatchFn1 = oneOfMatchFn(dictTranslateOneOf);
        return function () {
            return function () {
                return function () {
                    return {
                        translateError: function (v) {
                            return match(oneOfMatchFn1)(v);
                        }
                    };
                };
            };
        };
    };
};
var messageForStandardErrors = /* #__PURE__ */ (function () {
    return on1(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.validationError);
    })(on2(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unknownError);
    })(on3(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unexpectedResponse);
    })(on4(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unauthorized);
    })(on5(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.genericServerError);
    })(on6(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.networkError);
    })(on7(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unexpectedResponse);
    })(on8(Type_Proxy["Proxy"].value)(identity)(Data_OneOf["default$prime"](function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.genericServerError);
    })))))))));
})();
var messageForErrors = function (dictTranslatedError) {
    return on1(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.validationError);
    })(on2(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unknownError);
    })(on3(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unexpectedResponse);
    })(on4(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unauthorized);
    })(on5(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.genericServerError);
    })(on6(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.networkError);
    })(on7(Type_Proxy["Proxy"].value)(function (v) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.generic.errors.unexpectedResponse);
    })(on8(Type_Proxy["Proxy"].value)(identity)(translateError(dictTranslatedError)))))))));
};
var affBind = function () {
    return function (ma) {
        return function (f) {
            var coerce = function (v) {
                return v;
            };
            return bind(Control_Monad_Except_Trans.runExceptT(ma))(function (result) {
                if (result instanceof Data_Either.Right) {
                    return Control_Monad_Except_Trans.runExceptT(f(result.value0));
                };
                if (result instanceof Data_Either.Left) {
                    return pure(new Data_Either.Left(coerce(result.value0)));
                };
                throw new Error("Failed pattern match at Effect.AffE (line 50, column 3 - line 52, column 37): " + [ result.constructor.name ]);
            });
        };
    };
};
var affBind1 = /* #__PURE__ */ affBind();
var embed = function () {
    return function (aff) {
        return affBind1(aff)(pure1);
    };
};
export {
    oneOfMatchFn,
    translateError,
    affBind,
    embed,
    messageForErrors,
    messageForStandardErrors,
    translateOneOfNilRow,
    translateOneOfCons,
    translatedErrorOneOf
};
